import { Pagination, Space, Spin } from "antd";
import { ContentWrapper, DataTable } from "~/Components";
import { get } from "@services/api.service";
import { useEffect, useState } from "react";
import { useNotification } from "~/Hooks/useNotification";
import { getKey } from "@utils/CommonUtils";
import type { TableColumnsType } from "antd";
import { debounce } from "lodash";

export const BudgetManager = () => {
  const [data, setData] = useState<any>([]);
  const { openToast } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [orderBy, setOrderBy] = useState<string | null | undefined>("reviewerName");
  const [apiUrl, setApiUrl] = useState<any>("");
  const [searchString, setSearchString] = useState("");
  const page = currentPage - 1;
  const pageSize = 10;

  const handleTableSort = (column: any, currentOrder: string) => {
    console.log(column,currentOrder)
    if (!column?.dataIndex) return;

    const newOrder = currentOrder === "asc" ? "desc" : "asc";

    setCurrentPage(1);
    setOrderBy(column.dataIndex);
    setSortOrder(newOrder);
  };

  const renderValue = (value: any) => {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    return value;
  };

  const columns: TableColumnsType<any> = [
    {
      title: "Name",
      dataIndex: "reviewerName",
      key: "reviewerName",
      sorter: true,
      sortOrder: orderBy === "reviewerName" ? (sortOrder === "asc" ? "ascend" : "descend") : undefined,
      render: renderValue,
    },
    {
      title: "Email Id",
      dataIndex: "email",
      key: "email",
      sorter: true,
      sortOrder: orderBy === "email" ? (sortOrder === "asc" ? "ascend" : "descend") : undefined,
      render: renderValue,
    },
  ];

  const getBudgetManger = (page = currentPage, order = sortOrder, orderByField = orderBy) => {
    setIsLoading(true);
    const apiPage = page - 1;
    let url = `v1/budget-manager/list/get?page=${apiPage}&size=${pageSize}&searchText=${encodeURIComponent(
      searchString)}`;
    if (orderByField) {
      url += `&orderBy=${orderByField}&order=${order}`;
    }
    setApiUrl(url);
    get(url)
      .then((res: any) => {
        setTotalRecords(res.response.data.totalCount);
        setData(res.response.data.records);
      })
      .catch((err: any) => {
        openToast({
          content: err,
          type: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handlePageChange = (page: number) => {
    return setCurrentPage(page);
  };

    const handleSearchChange = debounce((value: string, isLoading: boolean) => {
      setSearchString(value);
      setIsLoading(isLoading);
    }, 1000);

  useEffect(() => {
    getBudgetManger(currentPage, sortOrder, orderBy);
  }, [currentPage, sortOrder, orderBy, searchString]);

  return (
    <>
      <ContentWrapper title="Budget Manager">
        {isLoading && (
          <div className="loadingOverlay">
            <Space size="middle">
              <Spin size="large" />
            </Space>
          </div>
        )}
        <DataTable
          tableData={
            data
              ? data?.map((d: any, index: number) => {
                  return {
                    ...d,
                    key: getKey(page, index),
                  };
                })
              : null
          }
          columns={columns?.map((column) => ({
            ...column,
            onHeaderCell: (column: any) => ({
              onClick: () => {
                if (column.sorter) {
                  handleTableSort(column, sortOrder);
                }
              },
            }),
          }))}
          tabOffset={60}
          isPagination={true}
          onSearchChange={handleSearchChange}
          isServerSearchApi={true}
          inputDisable={isLoading}
          searchPlaceholderText={"Search Budget Manager"}
          ctaColSpan={17}
          exportApiUrl={apiUrl}
          totalRecords={totalRecords}
          recordsPerPage={pageSize}
          exportFileName="Budget Manger"
        />
        <div className="pagination">
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalRecords}
            showSizeChanger={false}
            onChange={handlePageChange}
          />
        </div>
      </ContentWrapper>
    </>
  );
};
